import { render, staticRenderFns } from "./OneClickPrice.vue?vue&type=template&id=0fe74c44&scoped=true&"
import script from "./OneClickPrice.vue?vue&type=script&lang=js&"
export * from "./OneClickPrice.vue?vue&type=script&lang=js&"
import style0 from "./OneClickPrice.vue?vue&type=style&index=0&id=0fe74c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe74c44",
  null
  
)

export default component.exports